import {AbstractAdminEntityService} from "../../admin/AbstractAdminEntityService";
import {
    ScheduledTournamentConfig,
    ListScheduledTournamentResponse,
    TournamentConstraints
} from "../../../../generated/protocol";
import {AdminEntityService} from "../../admin/AdminEntityService";
import {injectable} from "inversify";

export const SCHEDULED_TOURNAMENT_SERVICE_NAME = "service";

export interface ScheduledTournamentService extends AdminEntityService<ScheduledTournamentConfig> {
    getConstraintsByUser(): Promise<TournamentConstraints>;

    archive(id: number): Promise<ScheduledTournamentConfig>;

    restore(id: number): Promise<ScheduledTournamentConfig>;
}

@injectable()
export class ScheduledTournamentServiceImpl extends AbstractAdminEntityService<ScheduledTournamentConfig, ListScheduledTournamentResponse> implements ScheduledTournamentService {

    constructor() {
        super("/poker/tournament");
    }

    getConstraintsByUser(): Promise<TournamentConstraints> {
        return this.http.doGet("/constaints/user");
    }

    archive(id: number): Promise<ScheduledTournamentConfig> {
        return this.http.doGet(this.entityPath + "/archive/" + id);
    }

    restore(id: number): Promise<ScheduledTournamentConfig> {
        return this.http.doGet(this.entityPath + "/restore/" + id);
    }

}


// WEBPACK FOOTER //
// ./src/app/service/poker/tournament/ScheduledTournamentService.ts